import React from "react";
import { translate } from "../../../utils/useful";

class CashStatement extends React.Component {
    render() {
        return (
            <div className="mx-3">
                <div className="flexcc flex-column">
                    <p style={{ fontSize: 12 }}>{translate('test')}</p>
                    <p>{translate('Cash Flow Statement')}</p>
                    {/* <div className="d-flex align-items-center">
                        <p style={{ fontSize: 12 }}>Basis: </p>
                        <p style={{ fontSize: 12 }}>Accrual</p>
                    </div> */}
                    <div className="d-flex align-items-center">
                        <p style={{ fontSize: 12 }}>{translate('From')}</p>&nbsp;
                        <p style={{ fontSize: 12 }}>2023/01/01</p>&nbsp;
                        <p style={{ fontSize: 12 }}>{translate('Up to')}</p>&nbsp;
                        <p style={{ fontSize: 12 }}>2023/01/31</p>&nbsp;
                    </div>
                </div>
                <div className="mt-3">
                    <div style={{ display: 'flex', justifyContent: 'flex-end', }}>
                        <p style={{ color: '#408dfb', fontSize: 13 }}>{translate('+ Add Temporary Note')}</p>
                    </div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb">
                    <div>
                        <p style={{ fontSize: 14 }}>{translate('Account')}</p>
                    </div>
                    <div>
                        <p style={{ fontSize: 14 }}>{translate('Total')}</p>
                    </div>
                </div>
                <div className="my-1" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="">
                    <div className="flexcb">
                        <div>
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Beginning Cash Balance')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-1" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="">
                    <div>
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Cash Flow from Operating Activities')}</p>
                    </div>
                    <div className="flexcb mt-1">
                        <div>
                            <p style={{ fontSize: 13, color: '#408dfb' }}>{translate('Net Income')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, color: '#408dfb' }}>0.0</p>
                        </div>

                    </div>
                    <div className="flexcb mt-1">
                        <div>
                            <p style={{ fontSize: 13, }}>{translate('Net cash provided by Operating Activities')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13, }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

                <div className="">
                    <div>
                        <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Cash Flow from Investing Activities')}</p>
                    </div>
                    <div className="flexcb">
                        <div>
                            <p style={{ fontSize: 13 }}>{translate('Net cash provided by Financing Activities')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 13 }}>0.0</p>
                        </div>

                    </div>

                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb">
                    <div></div>
                    <div><p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Net Change in cash')}</p></div>
                    <div><p style={{ fontSize: 13 }}>0.0</p></div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                <div className="flexcb">
                    <div></div>
                    <div><p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Ending Cash Balance')}</p></div>
                    <div><p style={{ fontSize: 13 }}>0.0</p></div>
                </div>
                <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

            </div>
        )
    }
}


export default CashStatement;